
    <!--
 * 竖版-活动规则
 * @LastEditTime: Mon Dec 23 2024 22:00:18 GMT+0800 (中国标准时间)
 -->
 <template>
  <a id="u_c_WZOJ19" href="javascript:;" :style="`background-color:${ pageData.btnColor }`" :class="[`normal btn-text`,`u_c_WZOJ19`]" @click="u_c_WZOJ19_event_G2FQ30($event)">{{`${ langData.infoBtn }`}}<div id="u_c_SI8L21"  v-show="compData.showInfoPopup || pageData.infoPopupState" :class="[`normal popup`,`u_c_SI8L21`]" @click="u_c_SI8L21_event_O6Z732($event)"><div id="u_c_UGK422"  :class="[`normal transparent-popup-content`,`u_c_UGK422`]" @click="u_c_UGK422_event_HANU33($event)"><a id="u_c_TW2N23" href="javascript:;" :class="[`normal transparent-popup-close`,`u_c_TW2N23`]" @click="u_c_TW2N23_event_NV9T31($event)"></a><div id="u_c_QOBC24"  :class="[`normal popup-title`,`u_c_QOBC24`]" >{{langData.infoBtn}}</div><div id="u_c_USVY26"  :class="[`normal`,`u_c_USVY26`]" ><div id="u_c_HTMV27"  v-html="compData.infoContent || langData.infoCollect" :class="[`normal `,`u_c_HTMV27`]" ></div></div></div></div></a>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"showInfoPopup":false,"infoContent":``},"ja-JP":{"showInfoPopup":false,"infoContent":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['ja-JP']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '活动规则';

    // 自定义setup - 开始
    compData.showInfoPopup = false
;
      // 活动规则的click事件
      const u_c_WZOJ19_event_G2FQ30= async (e)=>{
        try {pageData.infoPopupState = true} catch (error) {console.log(error)}
      };
      // 规则弹窗的click事件
      const u_c_SI8L21_event_O6Z732= async (e)=>{
        try {pageData.infoPopupState = false;} catch (error) {console.log(error)}
      };
      // 规则-弹窗内容的click事件
      const u_c_UGK422_event_HANU33= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 通用-关闭的click事件
      const u_c_TW2N23_event_NV9T31= async (e)=>{
        try {pageData.infoPopupState = false;} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_WZOJ19.normal{
position:absolute;
top:0.32rem;
right:0;
display:flex;
justify-content:center;
align-items:center;
font-size:0.35rem;
color:#fff1ce;
text-decoration:none;
padding:0.20rem 0.43rem;
border-radius:0.21rem 0 0 0.21rem;

}
}.default{
.u_c_SI8L21.normal{
z-index:20;

}
}.default{
.u_c_UGK422.normal{
position:relative;

}
}.default{
.u_c_TW2N23.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.default{
.u_c_QOBC24.normal{
position:relative;
margin-top:40%;

}
}.default{
.u_c_USVY26.normal{
position:relative;
width:90%;
height:60%;
margin:auto;
margin-top:0.55rem;
font-size:0.32rem;
color:#ffffff;
text-align:left;
font-weight:normal;
white-space:pre-wrap;
overflow-y:auto;

}
}.default{
.u_c_HTMV27.normal{
position:relative;
width:100%;
box-sizing:border-box;
white-space:pre-wrap;

}
}.ja-JP{
.u_c_WZOJ19.normal{
position:absolute;
top:0.32rem;
right:0;
display:flex;
justify-content:center;
align-items:center;
font-size:0.35rem;
color:#fff1ce;
text-decoration:none;
padding:0.20rem 0.43rem;
border-radius:0.21rem 0 0 0.21rem;

}
}.ja-JP{
.u_c_SI8L21.normal{
z-index:20;

}
}.ja-JP{
.u_c_UGK422.normal{
position:relative;

}
}.ja-JP{
.u_c_TW2N23.normal{
position:absolute;
top:0.19rem;
right:0.20rem;

}
}.ja-JP{
.u_c_QOBC24.normal{
position:relative;
margin-top:40%;

}
}.ja-JP{
.u_c_USVY26.normal{
position:relative;
width:90%;
height:60%;
margin:auto;
margin-top:0.55rem;
font-size:0.32rem;
color:#ffffff;
text-align:left;
font-weight:normal;
white-space:pre-wrap;
overflow-y:auto;

}
}.ja-JP{
.u_c_HTMV27.normal{
position:relative;
width:100%;
box-sizing:border-box;
white-space:pre-wrap;

}
}
</style>
